import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'

import { useFvNavigate } from '@fv/client-components'

import { InputAdornment, InputGroup } from './inputs/InputGroup'

type Props = {
  focusSearch?: boolean
  resetNav?: () => void
}

const TopNavSearch = ({ focusSearch, resetNav }: Props) => {
  const [searchText, setSearchText] = useState('')
  const navigate = useFvNavigate()
  const searchInput = useRef(null)

  useEffect(() => {
    if (focusSearch) {
      searchInput.current?.focus()
    }
  }, [focusSearch])

  return (
    <InputGroup
      className={clsx(
        'mb-0 flex-1 b1450:hidden',
        focusSearch ? '!block l-0' : 'ml-4',
      )}
      inputType="text"
      inputProps={{
        placeholder:
          'PRO#, BOL#, REF#, tracking#, GL Code, location or company',
        value: searchText,
        ref: searchInput,
        name: 'searchText',
        onChange: e => setSearchText(e.target.value),
        onKeyDown: e => {
          if (e.key === 'Enter' && searchText.trim()) {
            const text = encodeURIComponent(searchText.trim())
            setSearchText('')
            navigate(`/search?text=${text}`)
            resetNav?.()
          }
        },
      }}
      startContent={
        <InputAdornment
          icon="search"
          className="!bg-fv-green-50 !border-fv-green"
          iconClass="text-fv-green"
          position="start"
        />
      }
    />
  )
}
export default TopNavSearch
